import { io } from 'socket.io-client';

let connection;

export default {
  connect: () => {
    if (connection) {
      connection.disconnect();
    }

    connection = io(import.meta.env.VITE_APP_NEW_API_GATEWAY_API_URL, {
      path: '/v2/socket.io',
      transports: ['websocket'],
      withCredentials: true,
    });

    connection.on('connect', () => {
      console.log('connected', connection.id);
    });

    connection.on('event', (payload) => {
      console.log('event:', payload);
    });

    connection.on('connect_error', (err) => {
      console.error('connect_error:', err.message);
    });
  },
  disconnect: () => {
    if (connection) {
      connection.disconnect();
      connection = null;
    }
  },
};
